/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Venues_Delete_ReassignInputs */

const cs_settings_venues_delete_reassign = /** @type {(inputs: Settings_Venues_Delete_ReassignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přesunout lidi do`)
};

const en_settings_venues_delete_reassign = /** @type {(inputs: Settings_Venues_Delete_ReassignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move people to`)
};

/**
* | output |
* | --- |
* | "Move people to" |
*
* @param {Settings_Venues_Delete_ReassignInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_venues_delete_reassign = /** @type {((inputs?: Settings_Venues_Delete_ReassignInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Venues_Delete_ReassignInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_venues_delete_reassign(inputs)
	return cs_settings_venues_delete_reassign(inputs)
});